var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 7,
    viewBox: "0 0 15 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.515725 0.857564C0.515268 0.657545 0.596643 0.463702 0.745724 0.309687C0.829673 0.223004 0.932775 0.151351 1.04912 0.0988299C1.16547 0.0463091 1.29277 0.0139533 1.42375 0.00361563C1.55473 -0.00672201 1.6868 0.0051618 1.8124 0.0385861C1.93801 0.0720104 2.05467 0.126318 2.15572 0.1984L2.21307 0.239432C5.39524 2.51632 9.6631 2.55468 12.8857 0.335369C12.988 0.26426 13.1057 0.211157 13.232 0.179114C13.3584 0.14707 13.4908 0.136717 13.6219 0.14865C13.7529 0.160583 13.8799 0.194565 13.9955 0.248646C14.1112 0.302726 14.2132 0.375838 14.2957 0.463778C14.3867 0.552351 14.4554 0.656076 14.4974 0.768444C14.5394 0.880812 14.5538 0.999397 14.5397 1.11676C14.5256 1.23412 14.4833 1.34772 14.4155 1.45043C14.3477 1.55314 14.2559 1.64275 14.1457 1.71362L8.1457 5.84838C7.96677 5.97429 7.74233 6.04312 7.5107 6.04312C7.27908 6.04312 7.05464 5.97429 6.87571 5.84838L0.875725 1.56809C0.754707 1.48221 0.659044 1.37312 0.596496 1.24967C0.533947 1.12622 0.506274 0.991885 0.515725 0.857564Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.18841574b69ac218c5fd632437fc9aa2.svg";
export { ForwardRef as ReactComponent };